import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Duit Digital Branding */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img src="/imgs/Duit_Logo_chain.png" alt="Duit Digital Logo" className="w-10 h-10" />
              <div>
                <h2 className="text-xl font-bold text-white">Duit Digital</h2>
                <p className="text-xs text-gray-400">Smart Loan Solutions</p>
              </div>
            </div>
            <p className="text-sm">
              Empowering financial decisions with AI-driven loan recommendations.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              
            </h3>
            <ul className="space-y-2">
              {/* <li>
                <Link to="/partners" className="text-sm hover:text-teal-400">
                  Lending Partners
                </Link>
              </li> */}
              {/* <li>
                <Link to="/loans" className="text-sm hover:text-teal-400">
                  Loan Offerings
                </Link>
              </li> */}
              {/* <li>
                <Link to="/privacy-policy" className="text-sm hover:text-teal-400">
                  Privacy Policy
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Contact Info
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4" />
                <span className="text-sm">+91 8451048788</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4" />
                <span className="text-sm">info@duit.digital</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4" />
                <span className="text-sm">
                  WeWork Spectrum Tower - 5th Floor, 307,<br />
                  Chincholi Bunder Rd, Rajan Pada, Malad West,<br />
                  Mumbai 400064
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright Section */}
        <div className="mt-8 pt-8 border-t border-gray-800 text-sm text-center">
          <p>&copy; {new Date().getFullYear()} Duit Digital. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
